class HeaderScroll {
  constructor() {
    this.header = document.querySelector('.header');
    this.lastScroll = 0;
    this.scrollThreshold = 0; // Show header immediately on scroll up
    
    if (!this.header) return;
    
    // Add scroll event listener with debounce
    this.scrollHandler = this.debounce(() => this.handleScroll(), 10);
    window.addEventListener('scroll', this.scrollHandler);
    
    // Initial check in case page is loaded with scroll position
    this.handleScroll();
  }
  
  handleScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
    // If scrolled down, add scrolled class
    if (currentScroll > 10) {
      this.header.classList.add('scrolled');
    } else {
      this.header.classList.remove('scrolled');
    }
    
    this.lastScroll = currentScroll <= 0 ? 0 : currentScroll;
  }
  
  // Simple debounce function to improve performance
  debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }
}

// Initialize when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  new HeaderScroll();
});
